import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '@AppRoot/shared/services/shared.service';
import { debounceTime, fromEvent, map } from 'rxjs';
import { UtilityService } from '../utility.service';

interface Product {
  product_id: number;
  name: string;
  category_id: Array<number>;
  image: string;
  tags?: string;
  slug?:string;
}

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss'],
})
export class SearchModalComponent implements AfterViewInit {
  constructor(
    private router: Router,
    private _sharedService: SharedService,
    private utilityService: UtilityService
  ) {}

  searchProduct: string = '';
  @ViewChild('searchInput') searchInput!: ElementRef;
  loading = false;
  category!: number;

  products: Array<Product> = [];
  ngOnInit() {}

  ngAfterViewInit() {
    this.attachSearchInputListener();
  }

  attachSearchInputListener() {
    if (this.searchInput) {
      fromEvent<KeyboardEvent>(this.searchInput?.nativeElement, 'keyup')
        .pipe(
          debounceTime(500),
          map((event) => (event.target as HTMLInputElement).value)
        )
        .subscribe((value) => {
          this.loading = true;
          this.searchProduct = value;
          this.getSearchedProduct();
        });
    }
  }

  navigateToProduct(product: Product) {
    this.closeSearchModal();
    this.router.navigate(['/products/' + product.slug]);
  }

  navigateToProductList() {
    this.closeSearchModal();
    if (this.category) {
      this.router.navigate(['/products'], {
        queryParams: { category_id: this.category },
      });
    }else{
      this.router.navigate(['/products']);
    }
  }

  getSearchedProduct() {
    this.loading = true;
    if (this.searchProduct === '') {
      this.products = [];
      this.loading = false;
      return;
    }
    this.utilityService.getSearchedProducts(this.searchProduct).subscribe(
      (response) => {
        if (response.data.length != 0) {
          this.category = JSON.parse(response.data[0].category_id)[0];
        }
        this.products = response.data.map((product: any) => {
          return {
            ...product,
            category_id: JSON.parse(product?.category_id),
          };
        });
        this.loading = false;
      },
      (error) => {
        this.products = [];
        console.log(error);
        this.loading = false;
      }
    );
  }

  closeSearchModal() {
    this._sharedService.searchOpen.next(false);
  }

  tags(tags: any) {
    if (!tags) return '';
    return JSON.parse(tags).join(', ');
  }
}
